import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

class Signage extends Component {
  constructor(props) {
    super(props);
    this.renderLogo = this.renderLogo.bind(this);
    this.renderOrder = this.renderOrder.bind(this);
    this.renderOrderGroup = this.renderOrderGroup.bind(this);
  }

  componentDidMount() {
    this.props.loadOrders(this.props.match.params.locationId);

    // needed for automatic window movement.
    document.title = 'signage';
  }

  renderOrder(order) {
    if (!order) {
      return null;
    }

    const { classes } = this.props;

    return (
      <div className={classes.name} key={order.orderId}>
        <Typography variant="h5" className={classes.text} gutterBottom>
          {order.pickupName}
        </Typography>
      </div>
    );
  }

  renderOrderGroup(group, index) {
    const { classes, match } = this.props;

    const { locationId } = match.params;

    let headlineStyle = null;
    let columnStyle = null;
    if (this.props.orderGroups.length === 2 && index === 1) {
      headlineStyle = { direction: 'rtl' };
      columnStyle = { paddingLeft: locationId === '7335' ? 90 : 60 };
    }

    return (
      <div className={classes.column} key={group.name} style={columnStyle}>
        <Typography variant="h4" className={classes.headline} style={headlineStyle} gutterBottom>
          {group.name}
        </Typography>
        <div className={classes.names}>
          {group.orders && group.orders.map(this.renderOrder)}
        </div>
      </div>
    );
  }

  renderLogo(orderGroups) {
    // TODO proper whitelabel options
    return null;

    const { classes } = this.props;

    if (orderGroups.length === 2) {
      const iconPath = `${process.env.PUBLIC_URL}/icons/logo.png`;
      return (<div className={classes.logoWrapper}>
        <img src={iconPath} alt="logo" />
      </div>);
    }

    return null;
  }

  renderFocusedUser(orderGroups) {
    if (orderGroups.length < 2) {
      return null;
    }

    const { classes } = this.props;

    if (!orderGroups[1].orders.length) {
      return null;
    }

    return (
      <div className={classes.focusBox}>
        <Typography variant="h1" className={classes.focusText} gutterBottom>
          {orderGroups[1].orders[0].pickupName}
        </Typography>
      </div>
    );
  }

  render() {
    const { classes, orderGroups } = this.props;

    if (!orderGroups) {
      return null;
    }

    const { locationId } = this.props.match.params;

    if (!this.props.ordersPresent) {
      if (locationId === '747') {
        return (
          <div className={classes.placeholder}>
            <h1>Haubis App</h1>
            <h2>Vorab bestellen. Nicht warten.</h2>
            <h2>App herunterladen.</h2>
          </div>
        );
      }

      return (
        <div className={classes.wrapper}>
          <img src={`${process.env.PUBLIC_URL}/backgrounds/bobo_idle.jpg`} id="videoBackground" alt="idle screen" />
        </div>
      );
    }

    const videoPath = `${process.env.PUBLIC_URL}/backgrounds/bobo2.jpg`;

    return (
      <div className={classes.wrapper}>
        {/* <video height="auto" autoPlay muted loop id="videoBackground">
          <source src={videoPath} type="video/mp4" />
        </video> */}
        <img src={videoPath} id="videoBackground" alt="background screen" />
        <div className="signage-content">
          {this.renderLogo(orderGroups)}
          {this.renderFocusedUser(orderGroups)}
          <Grid
            container
            direction="row"
            alignItems="stretch"
            justify="flex-start"
            wrap="nowrap"
            className={classes.content}
          >
            {orderGroups.map(this.renderOrderGroup)}
          </Grid>
        </div>
      </div>
    );
  }
}

Signage.propTypes = {
  orderGroups: PropTypes.array,
  ordersPresent: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  loadOrders: PropTypes.func.isRequired,
  match: PropTypes.any.isRequired,
};

Signage.defaultProps = {
  loggedIn: false,
  orderGroups: null,
  ordersPresent: false,
};

const styles = () => ({
  wrapper: {
    backgroundColor: '#010001',
    height: '100vh',
    position: 'absolute',
    color: '#fff',
    padding: '40px',
    width: '100%',
    overflow: 'hidden',
  },
  content: {
    height: '65vh',
    top: '35vh',
    position: 'absolute',
    paddingRight: '30px',
  },
  placeholder: {
    textAlign: 'center',
    alignSelf: 'center',
    margin: 'auto',
    marginTop: '20%',
    '-webkit-transform': 'scale(3)',
    '-moz-transform': 'scale(3)',
  },
  focusBox: {
    position: 'absolute',
    top: 100,
    width: '100%',
  },
  focusText: {
    fontSize: 90,
    fontFamily: "'Yanone Kaffeesatz', sans-serif",
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#fff',
  },
  text: {
    color: '#fff',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: '280px',
    fontSize: '3rem',
    fontFamily: "'Yanone Kaffeesatz', sans-serif",
  },
  headline: {
    color: '#fff',
    // borderBottomColor: '#86bc24',
    // borderBottomStyle: 'solid',
    // borderBottomWidth: 20,
    fontWeight: '800',
    textAlign: 'center',
    fontFamily: "'Yanone Kaffeesatz', sans-serif",
    paddingBottom: '20px',
    marginRight: '20px',
    maxWidth: '100%',
  },
  column: {
    flex: 1,
    maxWidth: '50%',
    height: '100vh',
  },
  name: {
    flex: 1,
    flexGrow: 0,
    maxWidth: '300px',
    minWidth: '200px',
    marginRight: '20px',
  },
  names: {
    flex: 10,
    display: 'flex',
    maxWidth: '100%',
    flexWrap: 'wrap',
    marginLeft: '50px',
    maxHeight: 'calc(70vh - 150px)',
    flexDirection: 'column',
  },
  logoWrapper: {
    position: 'absolute',
    left: 'calc(50% - 137px)',
    width: '275px',
    top: '56px',
    paddingLeft: '20px',
    paddingRight: '20px',
    background: '#333',
  },
});

export default withStyles(styles)(Signage);
